import axios from 'axios';

// const url='http://192.168.100.181:5000';
const url = process.env.REACT_APP_BACKEND_URL;

export const LoginNew = async (
  data,
  handleAlertOpen,
  setAlertMessage,
  setAlertType,
  setIsLoading,
  setFieldValue,
  setData,
  setActivePage
) => {
  setIsLoading(true);
  let post = { usercode: data.username, password: data.password };
  try {
    await axios.post(`${url}/auth/user_login_new`, post).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);

        setAlertMessage(res.data.message);
        setAlertType('success');
        handleAlertOpen();
        // handleModalOpen();
        setData({ data: res.data, mobile: data.username, password: data.password, type: 'general' });
        setTimeout(() => {
          setActivePage(1);
        }, 2000);
      }
    });
  } catch (error) {
    console.log('error', error);

    if (error.response) {
      if (error.response.data.message) {
        setIsLoading(false);
        setAlertMessage(error.response.data.message);
        if (error.response.data.message === 'Incorrect Password') {
          setFieldValue('password', '');
        } else if (error.response.data.message === 'Mobile Number not found') {
          setIsLoading(false);
          setFieldValue('user_code', '');
          setFieldValue('password', '');
        }
      } else if (error.response.data.error) {
        setIsLoading(false);
        setAlertMessage(error.response.data.error);
        if (error.response.data.error === 'Incorrect Password') {
          setFieldValue('password', '');
        } else if (error.response.data.error === 'Mobile Number not found') {
          setIsLoading(false);
          setFieldValue('user_code', '');
          setFieldValue('password', '');
        }
      } else {
        setIsLoading(false);
        setAlertMessage('Something went wrong');
      }
    } else {
      setIsLoading(false);
      setAlertMessage('Something went wrong');
    }

    setAlertType('error');
    handleAlertOpen();
  }
};

export const Login = async (
  data,
  handleModalOpen,
  handleAlertOpen,
  setAlertMessage,
  setAlertType,
  setIsLoading,
  setFieldValue
  // Nav
) => {
  setIsLoading(true);
  let post = { usercode: data.username, password: data.password };
  try {
    await axios.post(`${url}/auth/user_login`, post).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);

        setAlertMessage(res.data.message);
        setAlertType('success');
        handleAlertOpen();
        handleModalOpen();
        // setTimeout(()=>{

        //   Nav("/user-role", { state: { data: res.data, mobile:data.username ,password:data.password} });
        // },2000)
      }
    });
  } catch (error) {
    if (error.response) {
      if (error.response.data.message) {
        setIsLoading(false);
        setAlertMessage(error.response.data.message);
        if (error.response.data.message === 'Incorrect Password') {
          setFieldValue('password', '');
        } else if (error.response.data.message === 'Mobile Number not found') {
          setFieldValue('phone', '');
          setFieldValue('password', '');
        }
      } else if (error.response.data.error) {
        setIsLoading(false);
        setAlertMessage(error.response.data.error);
        if (error.response.data.error === 'Incorrect Password') {
          setFieldValue('password', '');
        } else if (error.response.data.error === 'Mobile Number not found') {
          setFieldValue('phone', '');
          setFieldValue('password', '');
        }
      }
    } else {
      setIsLoading(false);
      setAlertMessage('Something went wrong');
    }

    setAlertType('error');
    handleAlertOpen();
  }
};

export const VerifyLoginNew = async (data, handleAlertOpen, setIsLoading, Nav, setOtp) => {
  try {
    setIsLoading(true);
    await axios.post(`${url}/auth/verify_user_login_new`, data).then((res) => {
      setIsLoading(false);
      if (res.status === 200) {
        // sessionStorage.setItem('login',
        sessionStorage.setItem('isLoggedin', true);
        sessionStorage.setItem('token', res.data.token);
        sessionStorage.setItem('UserType', res.data.user.user_type);
        sessionStorage.setItem('UserName', res.data.user.username);
        //  const cookies = res.headers['Set-Cookie'];
        // console.log(res);

        handleAlertOpen(res.data.message, 'success');
        // setTimeout(() => {
        if (data.user_type === 'corp') {
          Nav('/Department/ratna/transaction_reports');
        } else {
          if (res.data.reset_password === true) {
            Nav('/change-password');
          } else {
            Nav('/dashboard/default');
          }
        }

        // }, 1000);
        //   document.cookie = cookies;
      }
    });
  } catch (error) {
    console.log('error', error);

    setIsLoading(false);
    handleAlertOpen(error && error.response && error.response.data ? error.response.data.error : 'Something went wrong', 'error');
    setOtp('');
  }
};

export const ResendOtpNew = async (data, handleAlertOpen, setIsLoading, setCount) => {
  try {
    setIsLoading(true);
    await axios.post(`${url}/auth/user_login_new`, data).then((res) => {
      setIsLoading(false);
      handleAlertOpen(res.data.message, 'success');
      setCount(120);
    });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(
      error && error.response && error.response.data && error.response.data.error ? error.response.data.error : 'Something went wrong',
      'error'
    );
  }
};

export const ReSendOtp = async (data, handleModalOpen, handleAlertOpen, setAlertMessage, setAlertType, setIsLoading, setCount) => {
  setIsLoading(true);
  let post = { mobile_no: data.username, password: data.password };
  try {
    await axios.post(`${url}/auth/user_login`, post).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);

        setAlertMessage(res.data.message);
        setAlertType('success');
        handleAlertOpen();
        handleModalOpen();
        setCount(120);
      }
    });
  } catch (error) {
    console.log('error', error);

    if (error.response) {
      if (error.response.data.message) {
        setIsLoading(false);
        setAlertMessage(error.response.data.message);
        if (error.response.data.message === 'Incorrect Password') {
          setFieldValue('password', '');
        } else if (error.response.data.message === 'Mobile Number not found') {
          setFieldValue('phone', '');
          setFieldValue('password', '');
        }
      } else if (error.response.data.error) {
        setIsLoading(false);
        setAlertMessage(error.response.data.error);
        if (error.response.data.error === 'Incorrect Password') {
          setFieldValue('password', '');
        } else if (error.response.data.error === 'Mobile Number not found') {
          setFieldValue('phone', '');
          setFieldValue('password', '');
        }
      }
    } else {
      setIsLoading(false);
      setAlertMessage('Something went wrong');
      console.log('asdsa', error);
    }

    setAlertType('error');
    handleAlertOpen();
  }
};

export const Verify = async (data, handleAlertOpen, setAlertMessage, setAlertType, setIsLoading, setOtp) => {
  setIsLoading(true);
  // log
  let post = { mobile_no: data.username, otp: data.otp };
  try {
    await axios.post(`${url}/auth/verify_user_login`, post).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        // sessionStorage.setItem('login',
        sessionStorage.setItem('isLoggedin', true);
        sessionStorage.setItem('token', res.data.token);
        sessionStorage.setItem('UserType', res.data.user.user_type);
        sessionStorage.setItem('UserName', res.data.user.username);
        //  const cookies = res.headers['Set-Cookie'];
        // console.log(res);
        setAlertMessage(res.data.message);
        setAlertType('success');
        handleAlertOpen();
        // setTimeout(() => {
        if (res.data.user.user_type === 'corp') {
          window.location.href = '/Department/ratna/transaction_reports';
        } else {
          window.location.href = '/dashboard/default';
        }

        // }, 1000);
        //   document.cookie = cookies;
      }
    });
  } catch (error) {
    console.log(error);
    if (error.response) {
      setIsLoading(false);
      setAlertMessage(error.response ? error.response.data.error : 'Something went wrong');
      setOtp('');
    } else {
      setIsLoading(false);
      setAlertMessage('Something went wrong');
      setOtp('');
    }
    setAlertType('error');
    setIsLoading(false);
    handleAlertOpen();
  }
};

export const Logout = async (setIsloading) => {
  setIsloading(false);
  try {
    await axios
      .post(
        `${url}/auth/logout_new`,
        {},
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = '/';
          setIsloading(false);
        }
      });
  } catch (error) {
    console.log(error);
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = '/';
    setIsloading(false);
  }
};

export const SsoLogin = async (token, setAlertMessage, setAlertType, setOpenAlert) => {
  try {
    await axios
      .post(
        `${url}/auth/ms_validate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      )
      .then((res) => {
        console.log('res', res);
        sessionStorage.setItem('isLoggedin', true);
        sessionStorage.setItem('token', res.data.token);
        sessionStorage.setItem('UserType', res.data.user.user_type);
        sessionStorage.setItem('UserName', res.data.user.username);

        setAlertMessage('Logged in successful');
        setAlertType('success');
        setOpenAlert(true);

        setTimeout(() => {
          if (res.data.user.user_type === 'corp') {
            window.location.href = '/Department/ratna/transaction_reports';
          } else {
            window.location.href = '/dashboard/default';
          }
        }, 1000);
      })
      .catch((err) => {
        console.log('err', err);
        setAlertMessage(err.response ? err.response.data.error : 'Something went wrong');
        setAlertType('error');
        setOpenAlert(true);
      });
  } catch (error) {
    console.log('error', error);
    setAlertMessage(error.response ? error.response.data.error : 'Something went wrong');
    setAlertType('error');
    setOpenAlert(true);
  }
};

export const SsoLoginNew = async (token, setAlertMessage, setAlertType, setOpenAlert, setData, setActivePage) => {
  try {
    await axios
      .post(
        `${url}/auth/ms_validate_new`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      )
      .then((res) => {
        console.log('res', res);

        setAlertMessage(res.data.message);
        setAlertType('success');
        setOpenAlert(true);
        setData({ data: res.data, type: 'sso' });
        setActivePage(1);
      })
      .catch((err) => {
        console.log('err', err);
        setAlertMessage(err.response ? err.response.data.error : 'Something went wrong');
        setAlertType('error');
        setOpenAlert(true);
      });
  } catch (error) {
    console.log('error', error);
    setAlertMessage(error.response ? error.response.data.error : 'Something went wrong');
    setAlertType('error');
    setOpenAlert(true);
  }
};

export const SsoVerify = async (data, setIsLoading, handleAlertOpen) => {
  try {
    setIsLoading(true);
    await axios.post(`${url}/auth/ms_validate_verify_new`, data).then((res) => {
      setIsLoading(false);
      if (res.status === 200) {
        sessionStorage.setItem('isLoggedin', true);
        sessionStorage.setItem('token', res.data.token);
        sessionStorage.setItem('UserType', res.data.user_type);
        sessionStorage.setItem('UserName', res.data.user.username);
        handleAlertOpen(res.data.message, 'success');
        setTimeout(() => {
          if (res.data.user_type === 'corp') {
            window.location.href = '/Department/ratna/transaction_reports';
          } else {
            window.location.href = '/dashboard/default';
          }
        }, 1000);
      }
    });
  } catch (error) {
    setIsLoading(false);
    handleAlertOpen(error && error.response && error.response.data ? error.response.data.error : 'Something went wrong', 'error');
  }
};

// api
